import {getParsedId} from '@utils/helpers';
import {columnObjectAlignCenter, columnObjectAlignLeft} from '@utils/tableHelpers';
import {renderListOfNameOfFirstLevelDependency, setCdnColumn} from '@modules/events/components/EventsConfigurationTargets/utils/helpers';

export const Columns = {
    'id': {
        label: 'ID',
        sorting: (row) => getParsedId(row),
        header: {
            align: 'center',
            isCollapsed: true,
        },
        content: {
            align: 'center',
        },
    },
    'product': {
        label: 'Product',
        sorting: (row) => row.product.name,
    },
    'distribution_type': {
        label: 'Distribution type',
        sorting: true,
    },
    'stream_delay_type': {
        label: 'Stream delay type',
        sorting: true,
    },
    'is_default': {
        label: 'Default?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'device_categories': {
        label: 'Device categories',
        sorting: row => renderListOfNameOfFirstLevelDependency(row, 'device_categories'),
    },
    'cdn': {
        label: 'CDN',
        sorting: (row) => setCdnColumn('cdn', row),
    },
    'ingest_method': {
        label: 'Ingest method',
        sorting: true,
        ...columnObjectAlignLeft,
    },
    'encoder_type': {
        label: 'Encoders',
        sorting: true,
    },
    'encoding_job_profile': {
        label: 'Encoding job profile',
        sorting: true,
    },
    'stream_name_prefix': {
        label: 'Stream name prefix',
        sorting: true,
    },
    'has_playback_authentication': {
        label: 'Auth?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_scoreboard_overlay_support': {
        label: 'SB overlay?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_slate_support': {
        label: 'Slate?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_overlay_support': {
        label: 'Overlay?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_ad_support': {
        label: 'Ads?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_drm_support': {
        label: 'DRM?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_watermarking_support': {
        label: 'WM?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'has_cc': {
        label: 'CC?',
        sorting: true,
        ...columnObjectAlignCenter,
    },
    'actions': {
        label: 'Actions',
        ...columnObjectAlignCenter,
    },
};
